import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.css']
})
export class CoursesOfferedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
